import { StatusLevel } from '@/types';

/**
 * Tailwind-native status tokens — the `bg-success` / `text-warning` / etc.
 * utilities exist because `--color-success` etc. are declared in
 * src/styles/tailwind.css's `@theme` block.
 */
export const STATUS_LABEL: Record<StatusLevel, string> = {
  ok: 'Normal',
  warn: 'Warning',
  crit: 'Critical',
  off: 'Offline',
};

export const STATUS_DOT_CLASS: Record<StatusLevel, string> = {
  ok: 'bg-success',
  warn: 'bg-warning',
  crit: 'bg-error',
  off: 'bg-neutral',
};

export const STATUS_TEXT_CLASS: Record<StatusLevel, string> = {
  ok: 'text-success',
  warn: 'text-warning',
  crit: 'text-error',
  off: 'text-neutral',
};

export const STATUS_SOFT_BG_CLASS: Record<StatusLevel, string> = {
  ok: 'bg-success-light',
  warn: 'bg-warning-light',
  crit: 'bg-error-light',
  off: 'bg-neutral-light',
};

/** ~13% opacity halo ring behind a status dot, same colors as STATUS_DOT_CLASS. */
export const STATUS_HALO_CLASS: Record<StatusLevel, string> = {
  ok: 'shadow-[0_0_0_3px_rgba(31,138,95,0.13)]',
  warn: 'shadow-[0_0_0_3px_rgba(185,119,14,0.13)]',
  crit: 'shadow-[0_0_0_3px_rgba(192,57,43,0.13)]',
  off: 'shadow-[0_0_0_3px_rgba(91,107,110,0.13)]',
};
